import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

import { IndividualService } from '@features/contacts/services/individual.service';

import {
  IndividualDetailsComponent,
  Content
} from '../individual-details.component';

@Component({
  selector: 'spark-contacts-individual-edit',
  templateUrl: '../individual-details.component.html'
})
export class IndividualEditComponent
  extends IndividualDetailsComponent
  implements OnInit
{
  readonly isNewEntity = false;

  get title(): string {
    return 'Edit Individual';
  }

  get saveLabel(): string {
    return 'Save';
  }

  constructor(
    formBuilder: FormBuilder,
    individualService: IndividualService
  ) {
    super(formBuilder, individualService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  content(): Observable<Content> {
    return this.individualService.getIndividualWithSpecificContacts(
      this.individualId
    );
  }
}
